var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t出差申请-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "540px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 0 50px 30%"
    }
  }, [_c('el-steps', {
    attrs: {
      "space": 200,
      "active": 1,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "发起出差"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "审核中"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "审核通过"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px",
      "width": "86%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff_id"
    }
  }, [_c('el-input', {
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_name", $$v)
      },
      expression: "ruleForm.staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出差事由",
      "prop": "evection_reason"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入出差事由"
    },
    model: {
      value: (_vm.ruleForm.evection_reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "evection_reason", $$v)
      },
      expression: "ruleForm.evection_reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.ruleForm.evectionTripList), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "50px"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#006E4B",
        "font-weight": "900",
        "font-size": "20px"
      }
    }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "20px",
        "font-weight": "700"
      }
    }, [_vm._v("行程" + _vm._s(index + 1))]), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      staticStyle: {
        "float": "right",
        "margin-right": "20px"
      },
      attrs: {
        "src": require("../../../assets/icon/减少.png"),
        "width": "25px"
      },
      on: {
        "click": function($event) {
          return _vm.delTtinerary(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "border": "1px solid #DADADA",
        "margin-top": "10px"
      }
    }), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-top": "50px"
      },
      attrs: {
        "label": "交通工具",
        "prop": "dictionaries_id"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.evectionTripList[index].dictionaries_id),
        callback: function($$v) {
          _vm.$set(_vm.evectionTripList[index], "dictionaries_id", $$v)
        },
        expression: "evectionTripList[index].dictionaries_id"
      }
    }, _vm._l((_vm.dictionariesList), function(dictionaries) {
      return _c('el-option', {
        key: dictionaries.id,
        attrs: {
          "label": dictionaries.data,
          "value": dictionaries.id
        }
      })
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "单程往返"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.evectionTripList[index].trip_type),
        callback: function($$v) {
          _vm.$set(_vm.evectionTripList[index], "trip_type", $$v)
        },
        expression: "evectionTripList[index].trip_type"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "单程",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "往返",
        "value": "0"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "出发城市"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.evectionTripList[index].start_city),
        callback: function($$v) {
          _vm.$set(_vm.evectionTripList[index], "start_city", $$v)
        },
        expression: "evectionTripList[index].start_city"
      }
    }, _vm._l((_vm.$globals.cityList), function(city) {
      return _c('el-option', {
        key: city.city,
        attrs: {
          "label": city.city,
          "value": city.city
        }
      })
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "目的城市"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.evectionTripList[index].end_city),
        callback: function($$v) {
          _vm.$set(_vm.evectionTripList[index], "end_city", $$v)
        },
        expression: "evectionTripList[index].end_city"
      }
    }, _vm._l((_vm.$globals.cityList), function(city) {
      return _c('el-option', {
        key: city.city,
        attrs: {
          "label": city.city,
          "value": city.city
        }
      })
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "开始时间"
      }
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "type": "datetime",
        "format": "yyyy-MM-dd HH:mm",
        "value-format": "yyyy-MM-dd HH:mm",
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.evectionTripList[index].start_date),
        callback: function($$v) {
          _vm.$set(_vm.evectionTripList[index], "start_date", $$v)
        },
        expression: "evectionTripList[index].start_date"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "结束时间"
      }
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "type": "datetime",
        "format": "yyyy-MM-dd HH:mm",
        "value-format": "yyyy-MM-dd HH:mm",
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.evectionTripList[index].end_date),
        callback: function($$v) {
          _vm.$set(_vm.evectionTripList[index], "end_date", $$v)
        },
        expression: "evectionTripList[index].end_date"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "时长(小时)"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "80%"
      },
      model: {
        value: (_vm.evectionTripList[index].trip_duration),
        callback: function($$v) {
          _vm.$set(_vm.evectionTripList[index], "trip_duration", $$v)
        },
        expression: "evectionTripList[index].trip_duration"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "5%"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === (_vm.ruleForm.evectionTripList.length - 1)),
        expression: "index === (ruleForm.evectionTripList.length - 1)"
      }],
      attrs: {
        "src": require("../../../assets/icon/增加行程@2x.png")
      },
      on: {
        "click": function($event) {
          return _vm.AddTtinerary(index + 1)
        }
      }
    })])], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("同行人")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFinds
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff_name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.staff_names),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_names", $$v)
      },
      expression: "ruleForm.staff_names"
    }
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Add()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateAuditor()
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请选择姓名",
      "visible": _vm.dialogVisibles,
      "width": "40%",
      "center": true,
      "close-on-click-modal": true,
      "show-close": false,
      "modal-append-to-body": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请选择同行人",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": true,
      "show-close": false,
      "modal-append-to-body": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "checkbox",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_id
    },
    on: {
      "commit": _vm.saveChanges
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5cb13a4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ccsq/Ccsq_add.vue
// module id = null
// module chunks = 